import { render, staticRenderFns } from "./assets-details.vue?vue&type=template&id=8e78a322&scoped=true&"
import script from "./assets-details.vue?vue&type=script&lang=js&"
export * from "./assets-details.vue?vue&type=script&lang=js&"
import style0 from "./assets-details.vue?vue&type=style&index=0&id=8e78a322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78a322",
  null
  
)

export default component.exports